import script from "./MEntradaDeBusca.vue?vue&type=script&setup=true&lang=ts"
export * from "./MEntradaDeBusca.vue?vue&type=script&setup=true&lang=ts"

import "./MEntradaDeBusca.vue?vue&type=style&index=0&id=e8508418&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8508418"]])

export default __exports__